export const isEmail = (email?: string): boolean => {
    return Boolean(
        /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu.exec(
            email?.toLowerCase() ?? '',
        ),
    );
};
